import MultiShot from './MultiShot'
export default MultiShot
